import { useContext } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';

export default function OrderCardDetails({order, client, detailsFlag}) {
    const {primary_color, secondary_color} = useContext(AppContext);

    const deployOrderDetails=(order)=>{
        try{
            return order.map((_order, inx)=>{
                return <div key={`orderCard_${client.name}_${inx}`} className='orderCard_subDetails' dir='rtl'>
                    <p><b>שם מוצר:</b> {_order.name}</p>
                    <p><b>כמות:</b> {_order.amount}</p>
                    <p><b>מחיר:</b> {_order.price}₪</p>
                </div>
            })
        } catch(err){console.error("can't deploy orders",err)}
    }
  return (
    <div>{detailsFlag && <div className="orderCard_subDetailsDiv" style={{backgroundColor:secondary_color, color:primary_color}}>
        {deployOrderDetails(order.order)}
    </div>}</div>
  )
}
